export const pegarProcesso = ({ processo: { processo, infracao, requerente } }, id) => {
  return (!id && processo.id)
    ? {
      processo: {},
      requerente: {},
      infracao: {}
    }
    : {
      processo,
      infracao,
      requerente
    };
};


// WEBPACK FOOTER //
// ./src/paginas/processo/seletor.js